import React from "react";
import utilsService from "../../../servises/utils.service";
import styled from "styled-components";

const PartitionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 10px;
  min-width: 90px;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 255, 255, 0.08);
    transform: translateY(-1px);
  }
  
  h5 {
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 8px 0;
    text-align: center;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Consolas, monospace;
  }
  
  .beaker-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  
  .beaker {
    width: 32px;
    height: 70px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    
    .fill {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: ${props => props.color || 'rgb(0, 128, 213)'};
      transition: height 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      max-height: 100%;
      border-radius: 0 0 2px 2px;
    }
  }
  
  .measures {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.45);
    font-family: Consolas, monospace;
    gap: 2px;
    
    .used {
      color: rgba(255, 255, 255, 0.85);
      font-weight: 700;
    }
  }
`;

const TotalVerticalInfo = props => {
    const percent = utilsService.getPercent(props.currentOriginal || props.current, props.totalOriginal || props.total);
    const displayPercent = Number.isNaN(percent) ? 0 : percent;
    const barHeight = Math.min(100, Math.max(0, displayPercent));

    let fillColor = 'linear-gradient(180deg, rgb(0, 176, 255) 0%, rgb(0, 128, 213) 100%)';
    let textColor = 'rgb(0, 176, 255)';
    
    if (displayPercent > 70) {
        fillColor = 'linear-gradient(180deg, rgb(255, 210, 96) 0%, rgb(249, 190, 73) 100%)';
        textColor = 'rgb(249, 190, 73)';
    }
    
    if (displayPercent > 90) {
        fillColor = 'linear-gradient(180deg, rgb(255, 131, 123) 0%, rgb(248, 107, 99) 100%)';
        textColor = 'rgb(248, 107, 99)';
    }

    return (
        <PartitionCard color={ fillColor }>
            <h5 title={ props.title }>{ props.title }</h5>
            <div className="beaker-body">
                <div className="beaker">
                    <div className="fill" style={ { height: barHeight + "%" } }/>
                </div>
                <div className="measures">
                    <span className="used">{ Math.round(props.current * 100) / 100 } { props.currentExt }</span>
                    <span>/ { Math.round(props.total * 100) / 100 } { props.totaExt }</span>
                    <span style={ { fontSize: '9px', marginTop: '2px', opacity: 0.85, color: textColor, fontWeight: 700 } }>{ displayPercent }%</span>
                </div>
            </div>
        </PartitionCard>
    );
};

export default TotalVerticalInfo;
